export default "__VITE_ASSET__Bu4Hq5gj__"